<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                  <label>Show
                    <select name="users-list-select"
                      class="form-control form-control-sm d-inline-block width-100 p-right-25 pl-4 mx-1"
                      (click)="updateLimit($event)">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option Selected value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1">
                      <label for="ngx-filter-ref">Search:
                        <input id="ngx-filter-ref" class="form-control form-control-sm d-inline-block width-200 ml-1"
                          type="text" (keyup)="getLeadsFilter($event)" />
                      </label>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/resources/add">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Resources Guideline</button>
                  </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Content" prop="content" [width]="50">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <div class="cell-line-height cursor-pointer" [routerLink]="['/resources/view', row._id]">
                      <p class="font-medium-1 line-height-1 mb-0">
                        {{ row.content }}
                      </p>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Description" prop="description" [width]="70"></ngx-datatable-column>


              <ngx-datatable-column name="Actions" [width]="50"
                *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i class="ft-edit text-primary cursor-pointer mr-2" (click)="editResource(row)"></i>
                  <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                    (click)="Delete(row.id)"></i>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->

